angular.module('impactx.login').controller('LoginSamlErrorDialogCtrl', [
    '$routeParams',
    'AppConfiguration',
    'TranslationService',
    '$redirect',
    '$location',
    '$mdDialog',
    'themeFactory',
    '$config',
    LoginSamlErrorDialogController]);

function LoginSamlErrorDialogController($routeParams, AppConfiguration, TranslationService, $redirect, $location, $mdDialog, themeFactory, $config) {
    var self = this;
    self.theme = themeFactory.getTheme();
    var errors = $routeParams.errors;
    if (errors) {
        try {
            self.errors = JSON.parse($routeParams.errors);
            self.backToLoginLabel = TranslationService.get('backToLogin');
        } catch (e) {
            console.log(e);
            redirectToLoginPage();
        }
    }
    else {
        redirectToLoginPage();
    }

    self.redirect = function () {
        var portalUrl = AppConfiguration.get('externalAuthBBGPortalImpactX');
        var hasMultipleExternalAuthorizations = AppConfiguration.get('hasMultipleExternalAuthorizations');
        if (hasMultipleExternalAuthorizations) {
            $mdDialog.hide();
            $redirect.redirectTo(null, "/chooseexternallogin");
        }
        if (portalUrl) {
            $mdDialog.hide();
            $location.path(portalUrl);
        }
        else {
            redirectToLoginPage();
        }
    };

    function redirectToLoginPage() {
        $mdDialog.hide();
        $redirect.redirectTo(null, $config.loginRoute);
    }
}